import React, { useMemo } from 'react';
import classnames from 'classnames';
import Icon from 'components/Icon';

// @label: string | input's label
// @type: string | input's type
// @name: string | input's name
// @placeholder: string | input's placeholder
// @value: string | input's value
// @error: string | error's description
// @readOnly: boolean | should be editable?
// @className: string | additional classes
// @onChange: function | onChange handler
const Input = ({
	label,
	type,
	name,
	placeholder,
	value,
	error,
	readOnly,
	icon,
	className,
	onChange,
}) => {
	// Concat className with modifiers
	const cls = useMemo(() => classnames(
		'input__wrap',
		error && 'input__wrap--error',
		className
	), [
		error,
		className
	]);

	return (
		<div className="form__element">
			{/* Render label only if it has been passed */}
			{label && <label className="form__label">{label}</label>}

			<div className={cls}>
				{/* Render icon only if it has been passed */}
				{icon && <Icon icon={icon} className="input__icon" />}

				<input
					name={name}
					type={type}
					value={value}
					className="input"
					autoComplete="off"
					readOnly={readOnly}
					placeholder={type === 'password' ? '••••••••' : placeholder}
					onChange={onChange}
				/>

				{/* Render error only if it has been passed */}
				{error && <Icon icon="help_outline" className="error__icon" />}
			</div>
		</div>
	);
};

export default Input;
